const useQuestionAdvance = ({
  currentStepConfig,
  handleCameraStep,
  handleValidatedStep,
  handleSimpleStep,
}) => {
  const advanceQuestion = async (
    answerText,
    photoUrl = null,
  ) => {
    const step = currentStepConfig

    if (!step) return

    if (step.type === 'camera') {
      await handleCameraStep(step, photoUrl)
      return
    }

    if (step.validationApi) {
      await handleValidatedStep(step, answerText, photoUrl)
      return
    }

    await handleSimpleStep(step, answerText, photoUrl)
  }

  return {
    advanceQuestion,
  }
}

export default useQuestionAdvance